import { render } from "./bookPending.vue?vue&type=template&id=3d25d57c&scoped=true"
import script from "./bookPending.vue?vue&type=script&lang=js"
export * from "./bookPending.vue?vue&type=script&lang=js"

import "./bookPending.vue?vue&type=style&index=0&id=3d25d57c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d25d57c"]])

export default __exports__